import { decodeHex } from "#staxmpc/lib/encode";
import { verifyingKey } from "@stavax/schnorr-wasm";
export function buildMPCConfig(moduleConfig) {
  if (!moduleConfig) {
    throw new Error("missing stavaxMPC config");
  }
  if (!moduleConfig.dklsPartyServerURL) {
    throw new Error("missing stavaxMPC.dklsPartyServerURL config");
  }
  if (!moduleConfig.dklsPartyServerVerifyingKey) {
    throw new Error("missing stavaxMPC.dklsPartyServerVerifyingKey config");
  }
  if (!moduleConfig.dklsRelayServerEndpoint) {
    throw new Error("missing stavaxMPC.dklsRelayServerEndpoint config");
  }
  if (!moduleConfig.dklsRelayServerSecret) {
    throw new Error("missing stavaxMPC.dklsRelayServerSecret config");
  }
  const msgRelaySecretKey = decodeHex(moduleConfig.dklsRelayServerSecret);
  return {
    accessTokenKey: moduleConfig.accessTokenKey || "access_token",
    setup: {
      relay: moduleConfig.dklsRelayServerEndpoint,
      secretKey: msgRelaySecretKey,
      verifyingKey: verifyingKey(msgRelaySecretKey)
    },
    server: {
      endpoint: moduleConfig.dklsPartyServerURL,
      encryptionKey: moduleConfig.dklsPartyServerEncryptionKey ? decodeHex(moduleConfig.dklsPartyServerEncryptionKey) : new Uint8Array(),
      verifyingKey: decodeHex(moduleConfig.dklsPartyServerVerifyingKey)
    },
    requestTTL: moduleConfig.requestTTL || 15
  };
}
export const wsUrl = (path) => {
  if (path.startsWith("ws://") || path.startsWith("wss://")) {
    return path;
  }
  return path.replace("http", "ws");
};
